module.exports = "<div class=\"license\">\n        <div class=\"flex\">\n            <div class=\"flex-column\">\n                <sub>{{$ctrl.theTitle}}</sub>\n            </div>\n        </div>\n        <div class=\"flex flex-wrap flex-center\">\n            <as-doughnut-chart donut=\"$ctrl.chart1\"></as-doughnut-chart>\n            <as-doughnut-chart donut=\"$ctrl.chart2\"></as-doughnut-chart>\n        </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-appspace-id/licenseAppspaceId.component.html
// module id = 535
// module chunks = 0